import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom/cjs/react-router-dom.min';
import AddClasses from './AddClasses';
import Modal from '../../../basic-component/Modal'
const $ = require('jquery');
require('jszip');
require('pdfmake');
$.DataTable = require('datatables.net-bs4');
// require('datatables.net-bs4');
require('datatables.net-buttons-bs4');
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-buttons/js/buttons.flash.js');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-buttons/js/buttons.print.js');
require('datatables.net-keytable-bs4');
require('datatables.net-responsive-bs4');
class Classes extends Component {


    classData = [
        { classno: 1, classname: "Std 1", capacity: 40, teacher: "Sant Kumar Singh", starting: "10/10/2019", Ending: "10/10/2020", location: '3rd Floor' },
        { classno: 1, classname: "Std 1", capacity: 40, teacher: "Sant Kumar Singh", starting: "10/10/2019", Ending: "10/10/2020", location: '3rd Floor' },
        { classno: 1, classname: "Std 1", capacity: 40, teacher: "Sant Kumar Singh", starting: "10/10/2019", Ending: "10/10/2020", location: '3rd Floor' },
        { classno: 1, classname: "Std 1", capacity: 40, teacher: "Sant Kumar Singh", starting: "10/10/2019", Ending: "10/10/2020", location: '3rd Floor' },
        { classno: 1, classname: "Std 1", capacity: 40, teacher: "Sant Kumar Singh", starting: "10/10/2019", Ending: "10/10/2020", location: '3rd Floor' },
        { classno: 1, classname: "Std 1", capacity: 40, teacher: "Sant Kumar Singh", starting: "10/10/2019", Ending: "10/10/2020", location: '3rd Floor' },

    ]

    componentDidMount() {
        this.classData = this.classData.map((row) => {
            row['action'] = "<button class='btn btn-info btn-sm'><i class='fa fa-edit'></i></button>&nbsp;<button class='btn btn-danger btn-sm'><i class='fa fa-trash-o'></i></button>";
            return row
        });
        this.$el = $(this.el);
        var table = this.$el.DataTable({
            // lengthChange: false,
            dom: 'lBfrtip',
            data: this.classData,
            columns: [
                { data: 'classno' },
                { data: 'classname' },
                { data: 'capacity' },
                { data: 'teacher' },
                { data: 'starting' },
                { data: 'Ending' },
                { data: 'location' },
                { data: 'action' },
            ],

            buttons: [
                // {
                //     extend: 'pdf',
                //     text: 'PDF',
                //     className: 'btn btn-success'
                // },
                {
                    extend: 'csv',
                    text: 'CSV',
                    title: "Students Records",
                    className: 'btn btn-success btn-sm'
                },
                {
                    extend: 'print',
                    text: 'Print',
                    title: "<h1 class='text-center'>Student Record</h1>",
                    className: 'btn btn-success btn-sm'
                }
            ]
        });
        table.buttons().container().appendTo(".export-buttons ");
        $('#myTable tbody').on('dblclick', 'tr', function () {
            var data = table.row(this).data();
            console.log(data);
            alert('You clicked on ' + data.name + '\'s row');
        });

    }

    // addClassHandler = () => {
    //     console.log(this.props);
    //     this.props.history.push({
    //         pathname: this.props.match.url + "/AddClasses"
    //     });
    // }
    render() {
        let classesTable = (<div>
            {/* <h2 className="text-secondary" style={{ paddingLeft: "0.5rem", paddingTop: "1rem" }}>Student</h2> */}
            <div className="card card-design-2">
                <div className="card-header bg-primary text-white">
                    Classes List
                </div>
                <div className="card-body">
                    <div className="row">
                        {/* <div className="col-lg-4 col-sm-12">
                            <div className="row">
                                <div className="mr-1 pd-1"> Select Class</div>
                                <select className="form-control"><option>Std 1</option></select>
                            </div>
                        </div> */}
                        <div className="col-lg-12 col-sm-12 text-right export-buttons">
                            <button className="btn btn-primary btn-sm" data-toggle="modal" data-target="#myModal"><i className="fa fa-plus"></i> Add Class</button>&nbsp;
                            {/* <div className="export-buttons"></div> */}
                        </div>
                    </div>
                    <div className="row">
                        <div className=" table-responsive" style={{ padding: "10px" }}>
                            <table id="myTable" className="table table-hover table-bordered dt-responsive nowrap" width="100%" ref={el => this.el = el} >
                                <thead>
                                    <tr>
                                        <th>Class Name</th>
                                        <th>Class No</th>
                                        <th>Capacity</th>
                                        <th>Teacher</th>
                                        <th>Starting On</th>
                                        <th>Ending On</th>
                                        <th>Location</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
        return (
            <div>
                 <Modal header="Add Class" modalWidth="modal-xl" modalId="myModal" action="Add Class"><AddClasses /></Modal>
                {/* <Modal header="Student Info" modalWidth="modal-xl" modalId="studentInfoModal" action="Update"><Student studentDetail={this.state.currentStudent} /></Modal> */}
                {classesTable}
                {/* <div>
                    <Switch>
                        <Route path="/Classes/AddClasses" component={AddClasses} />
                        <Route path="/Classes" exact render={() => classes} />
                    </Switch>

                </div> */}
            </div>
        );
    }
}
export default Classes;